import { NavLink, NavItem } from "reactstrap";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { useDispatch } from 'react-redux';
import { ToggleMobileSidebar } from "../../../store/customizer/CustomizerSlice";

const NavSingleItem = ({to, icon, title, toggle, className, suffix, suffixColor,}) => {
  
  const dispatch = useDispatch();
  
  const HandletoggleNavbar = () => {
    dispatch(ToggleMobileSidebar());
  };


  return (
    <NavItem onClick={toggle} className={`${className} admin_list`}>
      <NavLink tag={Link} to={to} className="gap-0" onClick={HandletoggleNavbar}>
        <span className="sidebarIcon d-flex align-items-center">{icon}</span>
        <div className="d-flex flex-grow-1 align-items-center gap-1">
          <span className="ms-1">{title}</span>
          {suffix ? (
            <span className={`badge ms-auto ${suffixColor}`}>{suffix}</span>
          ) : (
            ""
          )}
        </div>
      </NavLink>
    </NavItem>
  );
};
NavSingleItem.propTypes = {
  title: PropTypes.string,
  to: PropTypes.string,
  icon: PropTypes.node,
  toggle: PropTypes.func,
  className: PropTypes.string,
  suffix: PropTypes.any,
  suffixColor: PropTypes.string,
};

export default NavSingleItem;
